import type { forms as formsEn } from '../en/forms';

export const forms: typeof formsEn = {
  shared: {
    time: 'Hora',
    note: 'Nota',
    notePlaceholder: 'Opcional, cualquier detalle que quiera recordar',
    adjust: 'Ajustar la hora o agregar una nota',
  },

  diaper: {
    title: 'Pañal',
    editTitle: 'Editar pañal',
    quickHint: 'Con un solo toque queda guardado, listo.',
    kindLabel: '¿Cómo estaba el pañal?',
    wet: 'Mojado',
    dirty: 'Sucio',
    both: 'Ambos',
  },

  weight: {
    title: 'Peso',
    editTitle: 'Editar peso',
    weightLabel: 'Peso',
    contextLabel: '¿Dónde se tomó este peso?',
    contexts: {
      birth: 'Peso al nacer',
      hospital: 'Hospital',
      office: 'Consultorio',
      home: 'En casa',
    },
    belowBirth: (pct: string) => `${pct}% por debajo del peso de nacimiento`,
    aboveBirth: (pct: string) => `${pct}% por encima del peso de nacimiento`,
    checkInNote: 'Vale la pena comentarlo al consultorio; querrán echarle un vistazo.',
  },

  pump: {
    title: 'Extracción',
    editTitle: 'Editar extracción',
    amountsLabel: 'Cantidad extraída',
    durationLabel: 'Duración (minutos)',
    total: (amount: string) => `Total de la sesión: ${amount}`,
  },

  sleep: {
    title: 'Sueño',
    editTitle: 'Editar sueño',
    startLabel: 'Se durmió',
    endLabel: 'Se despertó',
    endOptionalHint: 'Déjelo en blanco si el bebé sigue durmiendo.',
    fellAsleepNow: 'El bebé se durmió',
    wokeUpNow: 'El bebé se despertó',
    sleepingNow: 'Durmiendo ahora mismo',
    duration: (d: string) => `Durmió ${d}`,
    endBeforeStart: 'La hora de despertar debe ser después de la hora en que se durmió.',
  },

  units: {
    lb: 'lb',
    oz: 'oz',
    g: 'g',
    ml: 'ml',
  },
};
